import { z } from 'zod';

export const ITEM_PERMISSION_LEVEL = {
  NONE: 'NONE',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
} as const;

export const itemPermissionLevelSchema = z.enum(ITEM_PERMISSION_LEVEL);

export const itemPermissionSchema = z.object({
  itemId: z.number().int().positive(),
  permissionLevel: itemPermissionLevelSchema,
});

export type ItemPermissionLevelDTO = z.infer<typeof itemPermissionLevelSchema>;
export type ItemPermissionDTO = z.infer<typeof itemPermissionSchema>;
